import { Button, styled } from "@mui/material";

export const RoundedButton = styled(Button)(({ theme }) => ({
  backgroundColor: 'transparent',
  borderRadius: '100px',
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    color: '#ffffff'
  },
}));